export default __webpack_public_path__ + "static/media/p5_m.e0c532f6.png";